import QuickSearch from "../../../../../app/search/quick/model/quick-search";


export default class TopNavigationQuickSearch extends QuickSearch {

    // components class names to ignore clicks for click outside check
    public outsideClickIgnoreClasses    : string[] = ['search-settings-button', 'search-settings-popover']

    // is required for search input to be shown focused while interacting with settings button and popover
    public isFocused                    : boolean = false

    // is required for search results to stay while popover settings are hidden by click outside
    public isSettingsPopoverShown       : boolean = false

    reRender = () => {

        this.componentResults.reRender()
        this.componentInput.reRender()
    }

}